/* global define APP_CONFIG */
import { Record, List } from 'immutable';
import { DesignSections } from 'records/DesignSection';

const customersCanvasUrl = APP_CONFIG.ccUrl;
const defaultValues = {
  id: null,
  name: '',
  layoutName: '',
  templateContentFileId: null,
  contentUrl: '',
  previewUrl: '',
  contentName: '',
  contentFormat: null, // TODO: should this have a default?
  contentType: null, // TODO: should this have a default?
  contentDescription: '',
  ordinal: 0,
  designSections: DesignSections(),
  updatedContentName: '', //updated template content name
  updatedTemplateId: null,  //updated template content file id
  templateDescription: '',  //updated design background template description
  layoutId: -1,
  updatedPreviewUrl: '', //updated preview url for manage page component
  hiResBackgroundUrl: '',
};

function formatCustomersCanvasUrl(path) {
  const index = path.indexOf('UserDataFolder');
  let url = path.substring(index);
  url = url.replace(/\\/g, '/');
  return `${ customersCanvasUrl }/${ url }`;
}

export default class DesignPage extends Record(defaultValues, DesignPage) {
  constructor(values) {
    super({
      ...values,
      designSections: values && values.designSections
                      ? DesignSections(values.designSections)
                      : defaultValues.designSections,
      previewUrl: values && values.previewUrl
                  ? formatCustomersCanvasUrl(values.previewUrl)
                  : defaultValues.previewUrl,
    });
  }

  static getDesignPageOrdinalByPageId(designPages, pageId) {
    return designPages.find((designPage) => {
      return designPage.get('id') === pageId;
    });
  }
}

export const DesignPages = (data) => {
  let designPages = new List();
  if (data) {
    data.forEach((value) => {
      designPages = designPages.push(new DesignPage(value));
    });
  }
  return designPages;
};
